<template>
  <wa-page :is-showing-bandana="false" :is-showing-sitewide-modal="false">
    <wa-page-header
      slot="header"
      key="header"
    />

    <main
      slot="content"
      role="main"
      class="app-content"
    >
      <hero
        :last-updated="lastUpdated"
        :last-updated-formatted="lastUpdatedFormatted"
      />

      <div class="container padding-y-7xl">
        <div class="row roomy align-stretch margin-bottom-2xl laptop:margin-bottom-4xl">
          <div class="display-none laptop:display-block laptop:column-3 laptop:offset-1">
            <in-page-nav />
          </div>

          <div class="column-12 laptop:column-8 laptop:order-first">
            <background />
            <license />
            <what-the-customer-may-do />
            <what-creators-may-do />
            <what-creators-may-not-do />
            <updates />
            <downloads />
            <web-store-credentials-and-keys />
            <payment />
            <term />
            <enforcement />
            <guarantee />
            <disclaimer />
            <limited-damages />
            <general-contract-terms />
          </div>
        </div>

        <div class="margin-bottom-2xl">
          <see-free-license />
        </div>

        <license-sock slot="sock" />
      </div>
    </main>

    <wa-page-footer slot="footer" />
  </wa-page>
</template>

<script>
  import moment from 'moment'
  import { EventTrackingMixin } from 'app/mixins'
  import Background from './sections/pro/Background'
  import Disclaimer from './sections/pro/Disclaimer'
  import Downloads from './sections/pro/Downloads'
  import Enforcement from './sections/pro/Enforcement'
  import GeneralContractTerms from './sections/pro/GeneralContractTerms'
  import Guarantee from './sections/pro/Guarantee'
  import Hero from './sections/pro/Hero'
  import InPageNav from './sections/pro/InPageNav'
  import LicenseSock from './sections/LicenseSock'
  import License from './sections/pro/License'
  import LimitedDamages from './sections/pro/LimitedDamages'
  import Payment from './sections/pro/Payment'
  import SeeFreeLicense from './sections/pro/SeeFreeLicense'
  import Term from './sections/pro/Term'
  import Updates from './sections/pro/Updates'
  import WebStoreCredentialsAndKeys from './sections/pro/WebStoreCredentialsAndKeys'
  import WhatCreatorsMayDo from './sections/pro/WhatCreatorsMayDo'
  import WhatCreatorsMayNotDo from './sections/pro/WhatCreatorsMayNotDo'
  import WhatTheCustomerMayDo from './sections/pro/WhatTheCustomerMayDo'

  export default {
    name: 'ProLicenseView',

    components: {
      Background,
      Disclaimer,
      Downloads,
      Enforcement,
      GeneralContractTerms,
      Guarantee,
      Hero,
      InPageNav,
      LicenseSock,
      License,
      LimitedDamages,
      Payment,
      SeeFreeLicense,
      Term,
      Updates,
      WebStoreCredentialsAndKeys,
      WhatCreatorsMayDo,
      WhatCreatorsMayNotDo,
      WhatTheCustomerMayDo
    },

    mixins: [EventTrackingMixin],

    data() {
      return {
        lastUpdated: '2022-04-20'
      }
    },

    computed: {
      lastUpdatedFormatted() {
        return moment(this.lastUpdated).format('LL')
      }
    },

    mounted() {
      this.$posthog.capture('pro_license_view', this.determinationsEventProps)
    }
  }
</script>
